import type { ContentCollaboratorsQueryData } from '@confluence/details-panel/entry-points/ContentCollaboratorsQuery.ts';

export type AgentContributorAttribution = {
	/** Missing for anonymous/unknown people; names are not identities. */
	id: string | null;
	name: string;
	avatarURL?: string;
};

export type PageAgentContributor = {
	accountId: string;
	name: string;
	avatarURL: string;
	attributedUsers: AgentContributorAttribution[];
};

/** Preserve each agent entry with its single attributed person. */
export const normalizePageAgentContributors = (
	data: ContentCollaboratorsQueryData | undefined,
): PageAgentContributor[] =>
	(data?.confluence_contentCollaborators?.nodes ?? []).flatMap((node) => {
		if (!node?.agent) {
			return [];
		}

		const { agent, person } = node;
		return [
			{
				accountId: agent.accountId,
				name: agent.displayName ?? '',
				avatarURL: agent.profilePicture?.path ?? '',
				attributedUsers: [
					{
						id: person.accountId || null,
						name: person.displayName ?? '',
						avatarURL: person.profilePicture?.path,
					},
				],
			},
		];
	});
